import { NgModule } from '@angular/core';

import { SquareImageModule } from '@shared/core/components/squareImage';

import { ThumbForOrderTypeComponent } from './thumb-for-order-type.shared.component';

@NgModule({
    declarations: [
        ThumbForOrderTypeComponent,
    ],
    imports: [
        SquareImageModule
    ],
    exports: [
        ThumbForOrderTypeComponent,
    ],
})
export class ThumbForOrderTypeModule { }
